/* sv-cart.js — beteende för den anpassade kundvagnen (Svea/MittTips)
   Kräver: window.routes, Shopify.formatMoney, assets/cart-drawer.js
   Allt bindes delegerat på document så att sektionens omrendering aldrig tappar lyssnare. */
(function () {
  'use strict';
  if (window.__svCartInit) return;
  window.__svCartInit = true;

  var DAY = 86400000;
  var LOCALE = (document.documentElement.lang || 'sv-SE').indexOf('sv') === 0 ? 'sv-SE' : (document.documentElement.lang || 'sv-SE');

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function trimZeros(s) { return String(s).replace(/([.,])00(?![0-9])/, ''); }

  function money(cents, fallbackFormat) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return trimZeros(Shopify.formatMoney(cents, Shopify.money_format || fallbackFormat));
      }
    } catch (e) {}
    return (Math.round(cents / 100)).toLocaleString(LOCALE) + ' kr';
  }

  function drawer() { return q('cart-drawer'); }

  function refresh() {
    var cd = drawer();
    if (cd && typeof cd.refreshCartDrawer === 'function') return cd.refreshCartDrawer();
    if (typeof window.refreshCartDrawer === 'function') return window.refreshCartDrawer();
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        var nw = doc.querySelector('#CartDrawer');
        var old = q('#CartDrawer');
        if (nw && old) old.innerHTML = nw.innerHTML;
        boot();
      });
  }

  function cartPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().catch(function () { return {}; }); });
  }

  /* ---------------- stäng ---------------- */

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-sv-close]') : null;
    if (!t) return;
    var cd = drawer();
    if (cd && typeof cd.close === 'function') cd.close();
    else if (cd) cd.classList.remove('active', 'animate');
  });

  /* ---------------- fri frakt-mätare ---------------- */

  function initRail(root) {
    qa('[data-sv-fs]', root).forEach(function (fs) {
      var pct = Math.max(0, Math.min(100, parseFloat(fs.dataset.pct) || 0));
      var fill = q('.sv-rail__fill', fs);
      var knob = q('.sv-rail__knob', fs);
      if (!fill) return;
      function set(v) { fill.style.width = v + '%'; if (knob) knob.style.left = v + '%'; }
      if (fs.__svDone) { set(pct); return; }
      fs.__svDone = true;
      set(0);
      setTimeout(function () { set(pct); }, 60);
    });
  }

  /* ---------------- leveranslöfte ---------------- */

  function isBiz(d, weekend) { if (weekend) return true; var w = d.getDay(); return w !== 0 && w !== 6; }
  function nextBiz(d, weekend) { var x = new Date(d); while (!isBiz(x, weekend)) x = new Date(x.getTime() + DAY); return x; }
  function addBiz(d, n, weekend) {
    var x = new Date(d);
    for (var i = 0; i < n; i++) { x = new Date(x.getTime() + DAY); x = nextBiz(x, weekend); }
    return x;
  }
  function sameDay(a, b) { return a.toDateString() === b.toDateString(); }

  function fmtDate(d) {
    try { return new Intl.DateTimeFormat(LOCALE, { weekday: 'short', day: 'numeric', month: 'short' }).format(d).replace('.', ''); }
    catch (e) { return d.getDate() + '/' + (d.getMonth() + 1); }
  }

  function fmtLeft(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
    if (h > 0) return h + ' tim ' + m + ' min';
    if (m > 0) return m + ' min ' + (sec < 10 ? '0' : '') + sec + ' sek';
    return sec + ' sek';
  }

  function paintEta(el) {
    var cutoff = parseInt(el.dataset.cutoff, 10); if (isNaN(cutoff)) cutoff = 14;
    var lead = parseInt(el.dataset.lead, 10) || 0;
    var min = parseInt(el.dataset.min, 10) || 1;
    var max = parseInt(el.dataset.max, 10) || 3;
    var weekend = el.dataset.weekend === '1';
    var now = new Date();

    var cutoffAt = new Date(now); cutoffAt.setHours(cutoff, 0, 0, 0);
    var beforeCutoff = now < cutoffAt && isBiz(now, weekend);

    var ship = new Date(now);
    if (!beforeCutoff) ship = new Date(ship.getTime() + DAY);
    ship = nextBiz(ship, weekend);
    if (lead > 0) ship = addBiz(ship, lead, weekend);

    var tomorrow = new Date(now.getTime() + DAY);
    var shipWord = sameDay(ship, now) ? (el.dataset.today || 'idag')
      : sameDay(ship, tomorrow) ? (el.dataset.tomorrow || 'imorgon')
        : fmtDate(ship);

    var a1 = addBiz(ship, min, weekend);
    var a2 = addBiz(ship, max, weekend);
    var arrive = sameDay(a1, a2) ? fmtDate(a1) : fmtDate(a1) + ' – ' + fmtDate(a2);

    var s2 = q('[data-sv-eta-2]', el); if (s2) s2.textContent = shipWord;
    var s3 = q('[data-sv-eta-3]', el); if (s3) s3.textContent = arrive;

    var out = q('[data-sv-eta-urgtext]', el);
    if (out) {
      var tpl = beforeCutoff ? (el.dataset.urg || '') : (el.dataset.urgLate || '');
      if (tpl) {
        var txt = tpl.replace('[shipday]', shipWord);
        if (beforeCutoff) txt = txt.replace('[timer]', '<b>' + fmtLeft(cutoffAt - now) + '</b>');
        out.innerHTML = txt;
      }
    }
    return beforeCutoff;
  }

  function initEta(root) { qa('[data-sv-eta]', root).forEach(paintEta); }

  /* ---------------- upsells ---------------- */

  function upsellData(card) {
    if (card.__svData) return card.__svData;
    try { card.__svData = JSON.parse(card.dataset.variants || '{}'); } catch (e) { card.__svData = {}; }
    return card.__svData;
  }

  function paintUpsell(card) {
    var sel = q('[data-sv-upsell-select]', card);
    if (!sel) return;
    var v = upsellData(card)[sel.value];
    if (!v) return;
    var fmt = card.dataset.moneyFormat;
    var p1 = q('.sv-ups__p1', card), p2 = q('.sv-ups__p2', card), p3 = q('.sv-ups__p3', card), off = q('.sv-ups__off', card);
    var ref = v.orig && v.orig > v.page ? v.orig : v.page;
    if (p1) { if (v.orig && v.orig > v.page) { p1.textContent = money(v.orig, fmt); p1.style.display = ''; } else { p1.style.display = 'none'; } }
    if (p2) { if (v.page > v.ups) { p2.textContent = money(v.page, fmt); p2.style.display = ''; } else { p2.style.display = 'none'; } }
    if (p3) p3.textContent = money(v.ups, fmt);
    if (off) {
      var pct = ref > 0 ? Math.round((ref - v.ups) * 100 / ref) : 0;
      if (pct >= 5) { off.textContent = '−' + pct + '%'; off.style.display = ''; } else { off.style.display = 'none'; }
    }
    var img = q('.sv-ups__img img', card);
    if (img && v.img) { img.src = v.img; img.removeAttribute('srcset'); }
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest ? e.target.closest('[data-sv-upsell-select]') : null;
    if (!sel) return;
    var card = sel.closest('[data-sv-upsell]');
    if (card) paintUpsell(card);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-sv-upsell-add]') : null;
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('[data-sv-upsell]');
    var sel = card ? q('[data-sv-upsell-select]', card) : null;
    if (!sel || !sel.value || btn.classList.contains('is-busy')) return;

    btn.classList.add('is-busy');
    cartPost((window.routes && window.routes.cart_add_url) || '/cart/add', { items: [{ id: parseInt(sel.value, 10), quantity: 1 }] })
      .then(function (res) {
        btn.classList.remove('is-busy');
        if (res && res.status && res.status !== 200) {
          btn.classList.add('is-err');
          var lbl = q('span', btn); if (lbl) lbl.textContent = res.description || res.message || 'Fel';
          return;
        }
        btn.classList.add('is-done');
        var l = q('span', btn); if (l) l.textContent = btn.dataset.addedText || 'Tillagd';
        if (card) card.classList.add('is-added');
        return refresh();
      })
      .catch(function () { btn.classList.remove('is-busy'); });
  });

  /* ---------------- fraktskydd ---------------- */

  document.addEventListener('change', function (e) {
    var input = e.target.closest ? e.target.closest('[data-sv-prot-toggle]') : null;
    if (!input) return;
    var row = input.closest('[data-sv-prot]');
    if (!row || row.__svBusy) return;
    var id = parseInt(row.dataset.variant, 10);
    if (!id) return;
    row.__svBusy = true;
    var label = input.closest('label');
    if (label) label.classList.toggle('checked', input.checked);

    var p;
    if (input.checked) {
      p = cartPost((window.routes && window.routes.cart_add_url) || '/cart/add', { items: [{ id: id, quantity: 1 }] });
    } else {
      p = cartPost(((window.routes && window.routes.cart_change_url) || '/cart/change') + '.js', { id: String(id), quantity: 0 });
    }
    p.then(function () { return refresh(); })
      .catch(function () {})
      .then(function () { row.__svBusy = false; });
  });

  /* ---------------- rabattkod ---------------- */

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-sv-code-toggle]') : null;
    if (!t) return;
    var wrap = t.closest('[data-sv-code]');
    if (wrap) {
      wrap.classList.toggle('is-open');
      var i = q('input', wrap); if (i && wrap.classList.contains('is-open')) i.focus();
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('[data-sv-code-form]') : null;
    if (!form) return;
    e.preventDefault();
    var input = q('input', form);
    var code = input && input.value ? input.value.trim() : '';
    if (!code) return;
    var wrap = form.closest('[data-sv-code]');
    var btn = q('button', form);
    if (btn) btn.disabled = true;
    fetch('/discount/' + encodeURIComponent(code), { method: 'GET', credentials: 'same-origin' })
      .then(function () { return refresh(); })
      .catch(function () {})
      .then(function () {
        if (btn) btn.disabled = false;
        var msg = wrap ? q('.sv-code__msg', wrap) : null;
        if (!msg && wrap) { msg = document.createElement('div'); msg.className = 'sv-code__msg'; wrap.appendChild(msg); }
        if (msg) msg.textContent = 'Koden har tillämpats om den är giltig.';
      });
  });

  /* ---------------- boot ---------------- */

  function boot() {
    var root = q('#CartDrawer') || document;
    initRail(root);
    initEta(root);
    qa('[data-sv-upsell]', root).forEach(paintUpsell);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  ['cart-drawer:render', 'cart-drawer:update', 'cart:ajax-update', 'cart-drawer:open'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(boot, 40); });
  });

  setInterval(function () {
    var root = q('#CartDrawer');
    if (!root) return;
    qa('[data-sv-eta]', root).forEach(paintEta);
    initRail(root);
    qa('[data-sv-upsell]', root).forEach(function (c) { if (!c.__svPainted) { c.__svPainted = true; paintUpsell(c); } });
  }, 1000);
})();